import { render, staticRenderFns } from "./ExtractItemStatus.vue?vue&type=template&id=5957849a&scoped=true&"
import script from "./ExtractItemStatus.vue?vue&type=script&lang=ts&"
export * from "./ExtractItemStatus.vue?vue&type=script&lang=ts&"
import style0 from "./ExtractItemStatus.vue?vue&type=style&index=0&id=5957849a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5957849a",
  null
  
)

export default component.exports